<template>
    <HeaderPanel />
    <Toast />
    <div class="admin-container">
        <Button type="button" icon="pi pi-ellipsis-v" @click="toggle" aria-haspopup="true"
            aria-controls="overlay_menu" class="p-button-rounded p-button-text" />
        <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />

        <Card 
            v-if="showRegister" 
            class="register-card"
            style="align-items: center;"
        >
            <template #title>
                <h2 class="text-center">Регистрация нового пользователя</h2>
            </template>
            <template #content>
                <form 
                    @submit.prevent="newUser"
                    style="display: flex; flex-direction: column; align-items: center;"
                >
                    <div class="field">
                            <FloatLabel>
                                <InputText 
                                    id="username" 
                                    v-model="formData.username" 
                                    :class="{'p-invalid': errors?.username}"
                                    style="width: 100%;"
                                />
                                <label for="username">Имя пользователя</label>
                            </FloatLabel>
                        <small class="p-error" v-if="errors?.username">{{ errors.username }}</small>
                    </div>

                    <div class="field">
                        <FloatLabel>
                            <InputText 
                                id="email" 
                                v-model="formData.email"
                                type="email"
                                :class="{'p-invalid': errors?.email}"
                                style="width: 100%;"
                            />
                            <label for="email">Email</label>
                        </FloatLabel>
                        <small class="p-error" v-if="errors?.email">{{ errors.email }}</small>
                    </div>

                    <div class="field">
                        <FloatLabel>
                            <InputText 
                                id="password" 
                                v-model="formData.password" 
                                type="password"
                                style="width: 100%;"
                            />
                            <label for="password">Пароль</label>
                        </FloatLabel>
                        <small class="p-error" v-if="errors?.password">{{ errors.password }}</small>
                    </div>

                    <div class="field">
                        <FloatLabel>
                            <Dropdown 
                                id="role" 
                                v-model="formData.role" 
                                :options="roles || []"
                                optionLabel="description"
                                :class="{'p-invalid': errors?.role}"
                                style="width: 100%;"
                            />
                            <label for="role">Роль</label>
                        </FloatLabel>
                        <small class="p-error" v-if="errors?.role">{{ errors.role }}</small>
                    </div>

                    <Button type="submit" label="Зарегистрировать" class="p-button-primary" />
                </form>
            </template>
        </Card>
    </div>
</template>

<script>
import axios from 'axios';
import Menu from 'primevue/menu';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { z } from 'zod';
import HeaderPanel from '@/components/HeaderPanel.vue';
import Toast from 'primevue/toast';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Card from 'primevue/card';

export default {
    components: {
        Menu,
        HeaderPanel,
        Toast,
        Button,
        InputText,
        Dropdown,
        Card
    },
    data() {
        return {
            items: [
                { label: 'Новый пользователь', icon: 'pi pi-user-plus', command: () => this.showRegister = !this.showRegister },
                { label: 'База данных', icon: 'pi pi-database' }
            ],
            roles: null,
            showRegister: false,
            formData: {
                username: '',
                email: '',
                password: '',
                role: null
            },
            errors: {},
            resolver: zodResolver(
                z.object({
                    username: z.string().min(1, { message: 'Username is required.' }),
                    email: z.string().email({ message: 'Invalid email address.' })
                })
            )
        }
    },
    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        async newUser() {
            this.errors = {};
            
            // Валидация полей
            if (!this.formData.username) {
                this.errors.username = 'Имя пользователя обязательно';
            }
            if (!this.formData.email) {
                this.errors.email = 'Email обязателен';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
                this.errors.email = 'Некорректный email';
            }
            if (!this.formData.role) {
                this.errors.role = 'Выберите роль';
            }
            if (this.formData.password.length > 0 && this.formData.password.length < 8) {
                this.errors.password = 'Пароль должен быть не менее 8 символов';
            }

            if (Object.keys(this.errors).length > 0) {
                return;
            }

            try {
                const response = await axios.post("https://ncht.bz/api/auth/new-user", {
                    username: this.formData.username,
                    email: this.formData.email,
                    password: this.formData.password,
                    role: this.formData.role.id
                });

                if (response.status === 200) {
                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Успешно', 
                        detail: 'Пользователь успешно зарегистрирован', 
                        life: 3000 
                    });
                    this.showRegister = false;
                    this.formData = {
                        username: '',
                        email: '',
                        password: '',
                        role: null
                    };
                    /*const registerResponse = await axios.post("https://ncht.bz/api/mail/send-register-mail", { 
                        link: `https://ncht.bz/login/${btoa(this.formData.username)}`, 
                        username: this.formData.username 
                    });
                    
                    if (registerResponse.status === 200) {
                        this.$toast.add({ 
                            severity: 'success', 
                            summary: 'Успешно', 
                            detail: 'Пользователь успешно зарегистрирован', 
                            life: 3000 
                        });
                        this.showRegister = false;
                        this.formData = {
                            username: '',
                            email: '',
                            password: '',
                            role: null
                        };
                    }*/
                }
            } catch (error) {
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors;
                } else {
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Ошибка', 
                        detail: error.response?.data?.message || 'Произошла ошибка при регистрации', 
                        life: 3000 
                    });
                }
            }
        },
        showToast(message) {
            this.$toast.add({ severity: 'info', summary: 'Info', detail: message, life: 3000 });
        }
    },
    watch: {
        async showRegister(newVal) {
            if (newVal) {
                const response = await axios.get("https://ncht.bz/api/auth/roles");
                this.roles = response.data;
            }
        }
    }
}
</script>

<style scoped>
.admin-container {
    padding: 2rem;
}

.register-card {
    max-width: 500px;
    margin: 2rem auto;
}

.field {
    margin-bottom: 1.5rem;
    width: 50%;
}

.text-center {
    text-align: center;
}

:deep(.p-card) {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

:deep(.p-float-label) {
    margin-bottom: 0.5rem;
}

:deep(.p-error) {
    color: var(--red-500);
    font-size: 0.875rem;
    margin-top: 0.25rem;
}
</style>

